import { useParams } from 'react-router-dom'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { getIdWithPrefix } from 'utils/pathUtils'
import { useGetNursingHome } from 'services/nursingHome'
import LoadingScreen from 'components/Layout/LoadingScreen'
import useDocumentTitle from 'components/useDocumentTitle'
import {
  MobileCompanyPageShell,
  MobileCompanyNotFound,
} from 'components/MobileCompanyPage/MobileCompanyPageShell'
import { buildNursingHomePageContent } from './companyTypeData'

export function MobileNursingHomePage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const nursingHomeID = urlParams?.nursinghome_id
    ? getIdWithPrefix(
        urlParams.nursinghome_id,
        preferences?.company_type_prefix_map[ContactCompanyType.NursingHome]
      )
    : undefined

  const { data, isLoading } = useGetNursingHome(nursingHomeID)

  // Shared derivation — same stats/fields as the desktop NewNursingHomePage.
  const content = buildNursingHomePageContent(data)
  useDocumentTitle(isLoading ? 'Loading...' : content.documentTitle)

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!data || !content.contactCompanyId) {
    return <MobileCompanyNotFound label="Senior Living not found" />
  }

  return (
    <MobileCompanyPageShell
      contactCompanyId={content.contactCompanyId}
      companyName={content.header.name}
      domain={content.header.domain}
      summaryContent={content.summaryContent}
      locationDetailsContent={content.locationDetailsContent}
    />
  )
}
